import { Button } from "@/components/shadcn/button";

type LinkCellProps = {
  onClick: () => void,
  text: string | null | undefined,
  title?: string
};

export const LinkCell = ({ onClick, text, title }: LinkCellProps) => {
  return (
    <Button 
      variant="link" 
      size="sm" 
      title={title}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};
